"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedemptionManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AddReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "AddReservesOverflow",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowAndDepositBackFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowPaused",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "usdThreshold",
                type: "uint256",
            },
        ],
        name: "BorrowValueMustBeLargerThanThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "CantEnterPausedMarket",
        type: "error",
    },
    {
        inputs: [],
        name: "CantExitMarketWithNonZeroBorrowBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "CantSweepUnderlying",
        type: "error",
    },
    {
        inputs: [],
        name: "ComptrollerMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "EitherAssetOrDebtMustBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "cDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cBorrowVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suBorrowVal",
                type: "uint256",
            },
        ],
        name: "EitherAssetOrDebtMustBeZeroInGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpiredSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientCollateral",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientShortfall",
        type: "error",
    },
    {
        inputs: [],
        name: "InterMintNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBlockNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCloseFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidComptroller",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidDiscountRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidExchangeRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidGroupId",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInput",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInterestRateModel",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinSuBorrowValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReduceAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReserveFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureForRedeemFaceValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureLength",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidTimestamp",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsMax",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_SeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateCollateralMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketCanOnlyInitializeOnce",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MinDelayNotReached",
        type: "error",
    },
    {
        inputs: [],
        name: "MintMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MintPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MintTokensCantBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "NoRedemptionProvider",
        type: "error",
    },
    {
        inputs: [],
        name: "NotCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughForSeize",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingAfterRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingForMint",
        type: "error",
    },
    {
        inputs: [],
        name: "NotLiquidatableYet",
        type: "error",
    },
    {
        inputs: [],
        name: "NotSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdminOrPauser",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyListedCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPausedMarketCanBeUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPendingAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyRedemptionManager",
        type: "error",
    },
    {
        inputs: [],
        name: "OverThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "PriceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemTransferOutNotPossible",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSignerNotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "Reentered",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayBorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizePaused",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizeTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "Seize_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderMustBeCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "SetInterestRateModelMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SetReservesFactorMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenInOrAmountInMustBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferInFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferOutFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TooMuchRepay",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalBorrowsNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalSupplyNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "UnderlyingBalanceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowed",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_baseRate",
                type: "uint256",
            },
        ],
        name: "BaseRateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "LastFeeOpTimeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldComptroller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newComptroller",
                type: "address",
            },
        ],
        name: "NewComptroller",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldSigner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newSigner",
                type: "address",
            },
        ],
        name: "NewRedemptionSigner",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "BETA",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DECIMAL_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_BORROWING_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINUTE_DECAY_FACTOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REDEMPTION_FEE_FLOOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SECONDS_IN_ONE_MINUTE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "baseRateMap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "csuToken",
                type: "address",
            },
        ],
        name: "calcActualRepayAndSeize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "comptroller",
        outputs: [
            {
                internalType: "contract IComptroller",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "decayBaseRateFromBorrowing",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_totalSupply",
                type: "uint256",
            },
        ],
        name: "getCurrentRedemptionRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "getRedemptionRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_admin",
                type: "address",
            },
            {
                internalType: "address",
                name: "_redemptionSigner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lastFeeOperationTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastFeeOperationTimeMap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "csuToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "providers",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "redeemFaceValue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "csuToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "providers",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "providersDeadline",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "providersSignature",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "permitDeadline",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "permitSignature",
                type: "bytes",
            },
        ],
        name: "redeemFaceValueWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "csuToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "redemptionRateMantissa",
                type: "uint256",
            },
        ],
        name: "redeemFaceValueWithProviderPreview",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "redemptionSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IComptroller",
                name: "_comptroller",
                type: "address",
            },
        ],
        name: "setComptroller",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
        ],
        name: "setRedemptionSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class RedemptionManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.RedemptionManager__factory = RedemptionManager__factory;
RedemptionManager__factory.bytecode = _bytecode;
RedemptionManager__factory.abi = _abi;
//# sourceMappingURL=RedemptionManager__factory.js.map